
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Treatment() {
  const treatments = [
    {
      name: '70分スタンダードコース',
      duration: '所要時間：90分（初回は120分程度）',
      price: '11,000円（税込）',
      description: '脚背面・背中・脚前面・腕・お腹・デコルテの全身アロマトリートメント',
      benefits: ['ストレス解消', '血行促進', '筋肉の緊張緩和', '心身のリフレッシュ'],
      image: 'https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/1ead87197150f474bbb08ba15c2df996.jpeg'
    },
    {
      name: '40分クイックコース',
      duration: '所要時間：60分（初回は90分程度）',
      price: '7,700円（税込）',
      description: '脚背面・背中・脚前面・腕またはデコルテのお急ぎコース。ご予定の合間や、試しにアロマトリートメントを体験されてみたい方にもおすすめです',
      benefits: ['デトックス効果', 'むくみ改善', '新陳代謝向上', '免疫力アップ'],
      image: 'https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/61641ae1348d06fa80eac9115cf96a9c.jpeg'
    },
    {
      name: 'ドライヘッドスパ',
      duration: '所要時間：10分、20分、30分',
      price: '1,100円～3,300円（税込）',
      description: 'トリートメントに追加いただけるオプションです。デスクワークなどで頭痛や眼精疲労にお悩みの方におすすめ',
      benefits: ['頭皮の血行促進', '眼精疲労の緩和', '首肩こりの改善', '深いリラクゼーション'],
      image: 'https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/4fd72126d59169459b3516894fe8a7df.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-green-50"
      >
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">日本産精油トリートメント</h1>
          <p className="text-xl">和精油の力で心身を癒す、至福のひととき</p>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">完全個室・オーダーメイドのアロマトリートメント</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto mb-8"></div>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              elämäniでは、日本人の体質と相性が良いとされている、高品質でトレーサビリティの確かな国産精油とオイルのみを使用した施術をしております。国際資格をもつセラピストが、お客様のお悩みを丁寧にカウンセリングし、体調や気分に合わせて精油をブレンドすることで、心身を芯からほぐし、深いリラクゼーションへと導きます。
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-leaf-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">高品質な日本産精油を使用</h3>
                <p className="text-gray-600 text-sm">日本の森林から抽出されたトレーサビリティの確かな精油のみを使用</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-heart-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">オーダーメイドの施術</h3>
                <p className="text-gray-600 text-sm">その時々のお客様の体調や気分に合わせ、最適な精油を選びブレンド</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">国際資格セラピストによる技術</h3>
                <p className="text-gray-600 text-sm">英国に本部を置くIFPAの認定を受けた国際プロフェッショナルアロマセラピストによる施術</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Menu Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">トリートメントコース</h2>
          </div>
          
          <div className="space-y-8">
            {treatments.map((treatment, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                  <div className="p-8">
                    <div className="flex justify-between items-start mb-4">
                      <h3 className="text-2xl font-bold text-gray-900">{treatment.name}</h3>
                      <div className="text-right">
                        <div className="text-2xl font-bold text-green-600">{treatment.price}</div>
                        <div className="text-gray-500 text-sm">{treatment.duration}</div>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mb-6">{treatment.description}</p>
                    
                    <div className="grid grid-cols-2 gap-2 mb-6">
                      {treatment.benefits.map((benefit, i) => (
                        <div key={i} className="flex items-center text-gray-600">
                          <div className="w-4 h-4 flex items-center justify-center mr-2">
                            <i className="ri-check-line text-green-600"></i>
                          </div>
                          <span className="text-sm">{benefit}</span>
                        </div>
                      ))}
                    </div>
                    
                    <Link to="/contact">
                      <Button size="lg" className="w-full">
                        予約する
                      </Button>
                    </Link>
                  </div>
                  <div className="h-64 lg:h-auto">
                    <img 
                      src={treatment.image}
                      alt={treatment.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* トリートメントの流れ */}
      <section className="py-20 bg-green-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">トリートメントの流れ</h2>
          </div>
          <div className="max-w-4xl mx-auto space-y-16">
            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">1</div>
                  <h3 className="text-2xl font-bold text-gray-900">コンサルテーション</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  お客様のお悩みや既往歴等について丁寧にカウンセリングさせていただき、当日の体調や気分についてもお伺いします。
                </p>
              </div>
            </div>

            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">2</div>
                  <h3 className="text-2xl font-bold text-gray-900">精油の選定</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  コンサルテーションの結果をもとに、お客様に最適な日本産精油をセレクトします。
                  香りを実際に確認していただき、お好みに合わせて調整いたします。
                </p>
              </div>
            </div>

            {/* Step 3: お着替え */}
            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">3</div>
                  <h3 className="text-2xl font-bold text-gray-900">お着替え</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  お客様お一人だけのプライベートな完全個室で、ゆっくりとお着替えいただきます。
                </p>
              </div>
            </div>

            {/* Step 4: アロマトリートメント */}
            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">4</div>
                  <h3 className="text-2xl font-bold text-gray-900">アロマトリートメント</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  お客様の体調やご希望に合わせて選んだ日本産精油を使用し、丁寧にトリートメントを行います。心身ともにリラックスしていただけるよう、一人ひとりに合わせた施術を心がけています。
                </p>
              </div>
            </div>

            {/* Step 5: アフターケア */}
            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">5</div>
                  <h3 className="text-2xl font-bold text-gray-900">アフターケア</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  トリートメント後は、ハーブティーをお出しし、ゆっくりとお過ごしいただきます。日常生活でのアロマの活用方法についてもアドバイスいたします。
                </p>
              </div>
            </div>

            {/* Step 6: メッセージカードのお渡し */}
            <div className="flex items-center gap-8">
              <div className="w-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">6</div>
                  <h3 className="text-2xl font-bold text-gray-900">メッセージカードのお渡し</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  最後に、今回使用した精油の効能や、ご自宅でのケア方法などを記載した
                  オリジナルメッセージカードをお渡しします。日常生活でも香りを楽しんでいただけます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
